import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import shareIcon from '../images/shareIcon.svg';

function Share({ id }) {
  const [linkCopied, setLinkCopied] = useState(false);
  const { location: { pathname } } = useHistory();
  const clipboardCopied = () => {
    if (pathname.includes('/foods')) {
      navigator.clipboard.writeText(`http://localhost:3000/foods/${id}`);
    } else { navigator.clipboard.writeText(`http://localhost:3000/drinks/${id}`); }
    setLinkCopied(true);
    const twoSeconds = 2000;
    setTimeout(() => {
      setLinkCopied(false);
    }, twoSeconds);
  };

  return (
    <div>
      <div>
        <button
          className="share-button"
          onClick={ clipboardCopied }
          type="button"
        >
          <img
            data-testid="share-btn"
            src={ shareIcon }
            alt="share recipe"
          />
        </button>
        {linkCopied && <span>Link copied!</span>}
      </div>
    </div>
  );
}

Share.propTypes = {
  id: PropTypes.string.isRequired,
};

export default Share;
